import { CameraIcon, CrossCircledIcon } from '@radix-ui/react-icons';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

const PhotoSelector: React.FC<{
  url: string | null;
  label?: string;
  onChange: (newUrl: string | null, oldUrl: string | null) => void;
  justShow?: boolean;
}> = ({ url, label, onChange, justShow }) => {
  const selectPhoto = async () => {
    try {
      const image = await Camera.getPhoto({
        resultType: CameraResultType.Base64, // Get image as a file URI
        source: CameraSource.Photos, // Open the native photo selector
        quality: 90,
      });

      if (image.base64String) {
        onChange(`data:image/jpeg;base64,${image.base64String}`, url); // Call the parent onChange function
      }
    } catch (error) {
      console.error('Error selecting photo:', error);
    }
  };

  return (
    <div>
      <div className='border-neutral-neutral-7 mb-2.5 h-24 w-24 border-2 border-solid p-1'>
        {url ? (
          <div className='relative block h-full w-full max-w-full overflow-hidden align-middle'>
            {justShow ? null : (
              <div className='text-accent-accent-9 absolute top-0 right-0 cursor-pointer'>
                <CrossCircledIcon height={24} width={24} onClick={() => onChange(null, url)} />
              </div>
            )}

            <img className='max-h-full w-auto max-w-none' src={url} alt={'Foto'} />
          </div>
        ) : (
          <div className='relative inline-block h-full max-w-full align-middle'>
            <div className='mt-3 flex flex-col items-center justify-center gap-3'>
              <CameraIcon height={24} width={24} />

              <span className=''>{label || 'Aggiungi foto'}</span>
            </div>
            <div className='absolute top-0 right-0 bottom-0 left-0 h-full w-full opacity-0' onClick={selectPhoto} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoSelector;
